import { useContext } from 'react'
import styles from 'styles/SectionIntroScreen.module.css'
import classNames from 'classnames'
import { WebSocketContext } from "contexts/WebSocketContextProvider";

import Reveal from 'reveal.js'
import { useEffect } from 'react'

type SectionIntroScreenPropsType = {
  heading?: string;
  buttonText?: string;
  mascot?: string;
  classes?: any;
  slideTo?: number;
  isTeacher?: boolean;
  setSkipScreen?: any;
  slideIndex?: number;
}

function SectionIntroScreen({ heading, buttonText, mascot, classes, slideTo, isTeacher, setSkipScreen, slideIndex }: SectionIntroScreenPropsType) {

  useEffect(()=>{
    if(slideIndex === 8)
      setSkipScreen && setSkipScreen(false);
  },[slideIndex])

  const onClickButton = () => {
    setSkipScreen && setSkipScreen(true);
    slideTo ? Reveal.slide(slideTo) : Reveal.next();
  }

  return (
    <div className={styles.container}>
      <div className={classNames(styles.heading, classes.heading)}>
        { heading }
      </div>
      <div className={styles.imagesContainer}>
        <img
          src={mascot}
          alt='mascot'
          className={classNames(styles.image, classes.img)}
        />
      </div>
      { (buttonText && !!isTeacher) &&
        <div className={classNames(styles.button, classes.button)} onClick={onClickButton}>
        { buttonText }
        </div>
      }
    </div>
  )
}

export default SectionIntroScreen
